import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import IndirPage from "./pages/IndirPage";
import SertexMain from "@/components/SertexMain";
import LoginScreen from "@/components/LoginScreen";
import DragAutoScrollPoc from "@/components/DragAutoScrollPoc";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ConfirmRoot } from "@/lib/confirm";
import { Loader2 } from "lucide-react";

const Gate = () => {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="w-screen h-screen flex items-center justify-center bg-sertex-bg">
        <div className="flex items-center gap-2 text-sertex-cyan hud-text">
          <Loader2 className="h-4 w-4 animate-spin" />
          BAĞLANIYOR...
        </div>
      </div>
    );
  }

  // Giriş yapılmamışsa giriş ekranı gösterilir; adres (örn. /ayarlar) aynı
  // kaldığı için girişten sonra istenen bölüm doğrudan açılır.
  if (!user) return <LoginScreen />;
  return <SertexMain />;
};

/** Bilinmeyen adres — beyaz sayfa yerine sade Türkçe bilgi ekranı. */
const NotFound = () => (
  <div className="w-screen h-screen flex items-center justify-center bg-sertex-bg p-6">
    <div className="text-center space-y-3" data-testid="not-found-screen">
      <div className="hud-text text-sertex-cyan text-lg">SAYFA BULUNAMADI</div>
      <p className="text-sertex-textMuted text-sm">
        Aradığınız adres yok ya da taşınmış olabilir.
      </p>
      <a
        href="/"
        data-testid="not-found-home"
        className="inline-block px-4 py-2 rounded border border-sertex-cyan/40 text-sertex-cyan hud-text hover:bg-sertex-cyan/10 transition-colors"
      >
        ANA SAYFAYA DÖN
      </a>
    </div>
  </div>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Gate />} />
            {/* Kalıcı derin bağlantılar — hepsi aynı uygulama kabuğunu açar,
                ilgili bölüm SertexMain içinde adrese göre seçilir. */}
            <Route path="/yedekleme" element={<Gate />} />
            <Route path="/ayarlar" element={<Gate />} />
            {/* AŞAMA 7 POC — izole deneme sayfası (ana akışa dokunmaz). */}
            <Route path="/indir" element={<IndirPage />} />
            <Route path="/poc-surukleme" element={<DragAutoScrollPoc />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <ConfirmRoot />
      </AuthProvider>
    </div>
  );
}

export default App;
